import React, { useEffect, useState } from "react";
import { Cake, X } from "lucide-react";
import { api } from "../../lib/api";

/**
 * BirthdayBanner — sits at the top of the Community page (and could be
 * mounted anywhere). Reads /api/community/birthdays-today and renders a
 * cheerful celebration row for every camper whose birthday is today.
 *
 * Renders nothing if no birthdays — keeps the page clean 364 days a year.
 */
export default function BirthdayBanner() {
  const [list, setList] = useState([]);
  const [dismissed, setDismissed] = useState(false);

  useEffect(() => {
    let alive = true;
    api.get("/community/birthdays-today")
      .then(({ data }) => { if (alive) setList(data.birthdays || []); })
      .catch(() => {});
    return () => { alive = false; };
  }, []);

  if (dismissed || list.length === 0) return null;

  const names = list.map((b) => b.first_name + (b.age ? ` (${b.age})` : "")).join(", ");
  const cake = list.length === 1 ? "🎂" : "🎉🎂";

  return (
    <div
      data-testid="birthday-banner"
      className="mb-6 border-2 border-[#ff4500] bg-gradient-to-r from-[#fff4ec] via-[#fff8f3] to-[#fff4ec] p-4 flex items-center gap-3 relative"
    >
      <div className="text-3xl leading-none" aria-hidden>{cake}</div>
      <div className="flex-1 min-w-0">
        <div className="eyebrow text-[#ff4500] flex items-center gap-1.5 mb-0.5">
          <Cake className="w-3 h-3" /> Birthdays today
        </div>
        <div className="font-display text-base sm:text-lg leading-tight">
          {list.length === 1 ? (
            <>Wish <strong>{list[0].first_name}</strong>{list[0].age ? ` (now ${list[0].age})` : ""} a happy birthday around the camp&shy;fire 🥳</>
          ) : (
            <>Big birthday hugs to <strong>{names}</strong> from the whole CampCompass family 🥳</>
          )}
        </div>
      </div>
      <button
        onClick={() => setDismissed(true)}
        className="text-[#888] hover:text-[#111] p-1 flex-shrink-0"
        aria-label="Dismiss"
        data-testid="dismiss-birthday-banner"
      >
        <X className="w-4 h-4" />
      </button>
    </div>
  );
}
